
import Vue from "vue";
import { Company } from "@/models/company";
import { Subscription } from "@/models/subscription";
import { SubscriptionSerivce } from "@/services/subscription-service";
import AppCompanyPlan from "./CompanyPlan.vue";
import AppCompanyInfoWrapper from "./CompanyInfoWrapper.vue";

export default Vue.extend({
	data(){
		return {
			subscriptions: [] as Subscription[],
			shownSubscription: null as Subscription | null,
		};
	},
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	methods: {
		showPlan(subscription:Subscription){
			this.shownSubscription = subscription;
		},
		async fetchSubs(){
			this.subscriptions = await SubscriptionSerivce.getSubscriptions(this.company.id);
		}
	},
	async created(){
		this.fetchSubs();
	},
	components: {
		AppCompanyPlan,
		AppCompanyInfoWrapper
	}
});
